import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setDiscountPrize,
  setDiscountsMonitoring,
  setDiscountsVps,
  setSendDiscountStatus,
} from '@/redux/discount/discountSlice';

import discountService from '@/services/discountService';

const getDiscounts = () => async dispatch => {
  try {
    const response = await discountService.getDiscounts();

    const {
      data: { vps, monitoring },
    } = response;

    dispatch(setDiscountsVps(vps));
    dispatch(setDiscountsMonitoring(monitoring));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetDiscounts failure');
  }
};

const getPrize = category => async dispatch => {
  try {
    const response = await discountService.getPrize(category);

    const {
      data: { promo_id, discount },
    } = response;

    dispatch(setDiscountPrize({ promo_id, discount }));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetPrize failure');
  }
};

const sendDiscount = data => async dispatch => {
  try {
    await discountService.sendDiscount(data);

    dispatch(setSendDiscountStatus('success'));
  } catch (e) {
    if (e.response.status === 400) {
      dispatch(setSendDiscountStatus(e.response.data.message));
      return;
    }

    dispatch(setSendDiscountStatus('failure'));

    console.error(e);
    // Notify.failure(e.response?.data?.message || 'Request sendDiscount failure')
  }
};

export default {
  getDiscounts,
  getPrize,
  sendDiscount,
};
